import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
        <!-- <div class="footer clearfix">
        <span>&copy; Copyright Argic 2021</span>
    </div> -->
    `
})
export class AppFooterComponent {

}
